export const transformEmptyHelper = (value?: string | null) => {
  return value && value.length > 0 ? value : null;
};
